

<div class="file-options" *ngIf="isEditing">

    <div class="multipart-toggle">
        <label class="text-small">
          <input 
            type="checkbox" 
            [checked]="isMultipartUpload" 
            (change)="onToggleMultipart($event)" />
            This file contains more than one document
        </label>
      </div>
    
</div>